/* eslint-disable no-restricted-syntax */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

"use strict";

var unescape = require("./utils/unescape");
var urlHelper = require("app_ford_ar/helpers/urlHelpers");

let liveClick = [];
var impressionCounter = 0;

/**
* Binds a click event handler to the minimized chat button inside the Botmaker iframe.
* When the button is clicked, it triggers a data push event for opening the chat and logs the current page location.
* Handles cross-origin iframe access errors gracefully.
*
* @returns {boolean} - Returns true if the event was successfully bound, false otherwise.
*/
function bindChatClickEvent() {
    const $element = $("iframe[name='Botmaker']");
    var result = false;
    if ($element.length == 0) {
        return result;
    }

    const $doc = $element.contents();

    $doc.off("mousedown.chatMin", ".wc-button-minimized").on("mousedown.chatMin", ".wc-button-minimized", function () {
        CBTController.dataPush({
            event: "open_chat",
            page_location: window.location.href,
        });
    });
    result = true;

    return result;
}

/**
 * Resolves vehicle selector location by container context.
 * @param {jQuery} $container - vehicle selector container
 * @returns {string} location string
 */
function getVehicleSelectorLocation($container) {
    if (!$container || !$container.length) {
        return "";
    }

    if ($container.hasClass("vehicle-selector-search")) {
        return "plp";
    }

    if ($container.hasClass("vehicle-selector-pdp")) {
        return "pdp";
    }

    return "home";
}

/**
 * Builds payload with selected vehicle values from dropdowns.
 * @param {jQuery} $container - vehicle selector container
 * @returns {Object} payload
 */
function buildVehicleSelectPayload($container) {
    if ($container && $container.length) {
        var vehicleMake = $container.find(".vehicle-selector-dropdown[data-filterby='marca']").first().val();
        var vehicleModel = $container.find(".vehicle-selector-dropdown[data-filterby='modelo']").first().val();
        var vehicleYear = $container.find(".vehicle-selector-dropdown[data-filterby='ano']").first().val();
        var vehicleVersion = $container.find(".vehicle-selector-dropdown[data-filterby='version']").first().val();

        vehicleMake = vehicleMake === "0" ? "" : vehicleMake;
        vehicleModel = vehicleModel === "0" ? "" : vehicleModel;
        vehicleYear = vehicleYear === "0" ? "" : vehicleYear;
        vehicleVersion = vehicleVersion === "0" ? "" : vehicleVersion;

        if (!vehicleMake && !vehicleModel && !vehicleYear && !vehicleVersion) {
            return;
        }
        return {
            event: "vehicle_select",
            vehicle_make: vehicleMake,
            vehicle_model: vehicleModel,
            vehicle_year: vehicleYear,
            vehicle_version: vehicleVersion,
            page_location: window.location.href.toString(),
            selector_location: getVehicleSelectorLocation($container)
        };
    }
}

class CBTController {
    /**
     * function to push data to the dataLayer, and add hash
     * @param {Object} data - data to push
     */
    static hashPush(data) {
        var dataReassigned = data;
        if (dataReassigned) {
            const cbtEventParameters = JSON.parse(document.querySelector("input[name='cbt-events-parameters']").value);

            cbtEventParameters.forEach((eventParameter) => {
                if (eventParameter.eventName === dataReassigned.event) {
                    dataReassigned[eventParameter.paramName] = eventParameter.paramValue;
                }
            });

            if (dataReassigned.options !== "Quantity" || dataReassigned.options !== "Options") {
                delete dataReassigned.options;
            }
            if (dataReassigned.eventTypes) {
                delete dataReassigned.eventTypes;
            }
            if (dataReassigned.selector) {
                delete dataReassigned.selector;
            }
            // eslint-disable-next-line no-restricted-globals
            if ((location.hash.indexOf(dataReassigned.event + "cbt") === -1)) {
                dataLayer.push(dataReassigned);
            }
        }
    }
    /**
     * Parse the data object into json
     * @param {string} data
     * @returns {Object} jsonObject
     */

    static parseJSON(data) {
        var dataReassigned = data;
        let parsedJson = {};
        try {
            parsedJson = JSON.parse(dataReassigned);
        } catch (error) {
            // Handle cases of missing closing quote
            if (dataReassigned.length > dataReassigned.lastIndexOf("}")) {
                dataReassigned = dataReassigned.substring(0, dataReassigned.lastIndexOf("}") + 1);
            }
            parsedJson = JSON.parse(dataReassigned.replace(/'/gi, "\"").replace(/\\"/, "'"));
        }
        return parsedJson;
    }

    /**
    * Calculates the product counter index based on the current page's URL query parameters.
    * Extracts the "sz" (page size) and "start" (start index) parameters from the URL to determine
    * the current product counter, which is typically used for pagination purposes.
    *
    * @returns {number} The calculated product counter index, or -1 if the required query parameters are missing or invalid.
    */
    static getProductCounter() {
        var productCounter = -1;

        var pageUrl = window.location.href;
        var sz = pageUrl ? urlHelper.getQueryStringValue(pageUrl, "sz") : null;
        var start = pageUrl ? urlHelper.getQueryStringValue(pageUrl, "start") : null;

        if (sz && start) {
            var parsedSz = parseInt(sz, 10);
            var parsedStart = parseInt(start, 10);

            if (!isNaN(parsedSz) && !isNaN(parsedStart) && parsedStart > 0) {
                var currentPage = parsedStart / parsedSz;
                productCounter = currentPage > 0 ? parsedSz * currentPage - 1: productCounter;
            }
        }

        return productCounter;
    }

    /**
    * Determines the appropriate banner location string based on the provided banner data and the current page context.
    * If the page is a Page Designer page, the banner location is dynamically updated to reflect the specific page name.
    *
    * @param {Object} bannerData - The banner data object containing at least a 'banner_location' property.
    * @param {string} bannerData.banner_location - The original banner location string, typically formatted as "<page>-<location>".
    * @returns {string} The resolved banner location string, potentially modified to match the current Page Designer page context.
    */
    static getBannerLocation(bannerData) {
        var bannerLocation = bannerData.banner_location;
        var pdPageType = $("input[name='cbt-page-type-pd']");

        // if not page designer page, return
        if (!pdPageType || !pdPageType.length) {
            return bannerLocation;
        }

        // if by any chance banner_location doesn't have a page of type of banner, return
        var bannerLocationArr = bannerData.banner_location.split("-");
        if (!bannerLocationArr.length || bannerLocationArr.length < 2) {
            return bannerLocation;
        }

        // if not page designer page, return
        var bannerLocationPage = bannerLocationArr[0];
        if (bannerLocationPage !== "pagedesigner") {
            return bannerLocation;
        }

        // if without value, return
        if (!pdPageType[0].value) {
            return bannerLocation;
        }

        // if page designer page, replace for the page name following existing pattern (lowercase and without space)
        var newBannerLocationPage = pdPageType[0].value.toLowerCase().replace(/ /g, "");
        return `${newBannerLocationPage}-${bannerLocationArr[1]}`;
    }

    /**
    * Observes all unobserved banner elements on the page and assigns them a unique index per banner location.
    * Adds the "observed" class to each banner after observation.
    *
    * @param {IntersectionObserver} bannerObserver - The IntersectionObserver instance used to observe banner elements.
    */
    static observeBanners(bannerObserver) {
        var newBanners = document.querySelectorAll(".viewBannerTrigger:not(.observed)");
        var bannerTypeCounters = {};

        newBanners.forEach((banner) => {
            var bannerLocation = banner.dataset.bannerLocation || "";

            if (bannerLocation) {
                if (!bannerTypeCounters[bannerLocation]) {
                    bannerTypeCounters[bannerLocation] = 1;
                }

                banner.dataset.bannerIndex = bannerTypeCounters[bannerLocation];
                bannerTypeCounters[bannerLocation] += 1;
            }

            bannerObserver.observe(banner);
            banner.classList.add("observed");
        });
    }

    /**
    * Callback function for IntersectionObserver to handle banner view events.
    * Tracks when banners become visible in the viewport and pushes analytics data if a banner remains visible for at least 1 second.
    * Removes the observer and timer once the event is pushed, and cancels timers if the banner leaves the viewport before the threshold.
    *
    * @param {IntersectionObserverEntry[]} entries - Array of intersection observer entries representing observed banners.
    * @param {IntersectionObserver} bannerObserver - The IntersectionObserver instance observing the banners.
    * @param {Map<Element, number>} visibleTimers - Map tracking timers for each visible banner element.
    */
    static bannerViewObserverCallback(entries, bannerObserver, visibleTimers) {
        entries.forEach(entry => {
            var el = entry.target;

            if (entry.isIntersecting) {
                if (!visibleTimers.has(el)) {
                    // initiate timer to only push event if banner is visible for at least 1 second
                    var timer = setTimeout(() => {
                        var data = CBTController.parseJSON(el.dataset.cbt);
                        el.removeAttribute("data-cbt");

                        var index = el.dataset.bannerIndex;
                        data.creative_slot = index;

                        var bannerLocation = CBTController.getBannerLocation(data);
                        data.banner_location = bannerLocation + "-" + index;

                        CBTController.dataPush(data);
                        bannerObserver.unobserve(el);
                        visibleTimers.delete(el);
                    }, 1000);

                    visibleTimers.set(el, timer);
                }
            } else if (visibleTimers.has(el)) {
                clearTimeout(visibleTimers.get(el));
                visibleTimers.delete(el);
            }
        });
    }

    /**
     * check data type and parse string into JSON
     * @param {Object} data - data to push
     */
    static dataPush(data) {
        var dataReassigned = data;
        if ((typeof (dataReassigned) === "string") && (dataReassigned !== "")) {
            if ((dataReassigned != null) || (dataReassigned !== "null")) {
                dataReassigned = CBTController.parseJSON(unescape(dataReassigned));
                CBTController.hashPush(dataReassigned);
            }
        } else {
            CBTController.hashPush(data);
        }
    }

    /**
    * Callback for tile view observer
    * @param {Array} entries - array of observed entries
    * @param {Object} observer - observer object
    * @param {Object} node - node object
    */
    static tileViewObserverCallback(entries, observer, node) {
        var productItems = [];
        let matchedID;

        let allProductTiles = node.querySelectorAll("[data-itemid]");
        if (!allProductTiles.length) {
            return;
        }

        entries.forEach(entry => {
            if (entry.isIntersecting && window.impressionsContainer) {
                observer.unobserve(entry.target);
                var productID = entry.target.getAttribute("data-itemid");
                let matchingProduct = Array.from(allProductTiles).find(tile => {
                    return tile.getAttribute("data-itemid") === productID;
                });
                if (matchingProduct) {
                    matchedID = matchingProduct.getAttribute("data-itemid");
                }
                window.impressionsContainer = window.impressionsContainer.filter((impression) => {
                    var result = true;
                    if (impression.item_id === matchedID || impression.item_variant.includes(matchedID)) {
                        productItems.push(impression);
                        result = false;
                    }
                    return result;
                });
            }
        });

        let dataLayerObj = {
            event: "view_item_list",
            ecommerce: {}
        };
        dataLayerObj.ecommerce.currency = "ARS";
        dataLayerObj.ecommerce.items = productItems;

        if (dataLayerObj.ecommerce.items.length > 0) {
            CBTController.dataPush(dataLayerObj);
        } else {
            dataLayerObj = "";
        }
    }

    /**
    * Finds all data DOM elements and pushes them to the data layer
    * @param {HTMLElement} node - the node containing the data-cbt attribute
    * @param {boolean} initialLoad - whether this is the initial page load
    */
    static findAllDataDOM(node, initialLoad) {
        let dataCollectionObj = {};

        if (!window.impressionsContainer || initialLoad) {
            window.impressionsContainer = [];
        }

        const observer = new IntersectionObserver((entries) => {
            CBTController.tileViewObserverCallback(entries, observer, node);
        }, {
            threshold: 1
        });

        // for view_banner event
        var visibleTimers = new WeakMap(); // to control time of visibility

        var bannerObserver = new IntersectionObserver((entries) => {
            CBTController.bannerViewObserverCallback(entries, bannerObserver, visibleTimers);
        }, {
            threshold: 0.5
        });

        /**
        * Push data layer objects to the data layer
        * @param {HTMLElement} node - the node containing the data-cbt attribute
        * @returns {Array} impressionsContainer - an array of items
        */
        function dataPushDataLayerObj() {
            const allCBTData = node.querySelectorAll("[data-cbt]");
            if (!allCBTData.length) {
                return false;
            }

            allCBTData.forEach((tempNode) => {
                dataCollectionObj = CBTController.parseJSON(tempNode.getAttribute("data-cbt"));
                if (dataCollectionObj && dataCollectionObj.event === "view_item_list") {
                    dataCollectionObj.ecommerce.items.index = impressionCounter;
                    impressionCounter += 1;
                }

                if (dataCollectionObj && dataCollectionObj.action === "Search" && dataCollectionObj.label) {
                    CBTController.dataPush(dataCollectionObj);
                }
                if (!dataCollectionObj || !dataCollectionObj.eventTypes || !dataCollectionObj.event) {
                    return;
                }

                const eventTypes = dataCollectionObj.eventTypes.split(",");

                if (eventTypes.includes("show")) {
                    if (eventTypes.includes("click")) {
                        dataCollectionObj.category = "Click";
                        CBTController.dataPush(dataCollectionObj);
                        return;
                    }
                    if (dataCollectionObj.event === "view_item_list") {
                        window.impressionsContainer.push(dataCollectionObj.ecommerce.items);
                    } else if (dataCollectionObj.event !== "view_banner") {
                        CBTController.dataPush(dataCollectionObj);
                    }

                    // don't remove from view_banner so it can be observed and properly pushed
                    if (dataCollectionObj.event !== "view_banner") {
                        tempNode.removeAttribute("data-cbt");
                    }
                }
            });

            // eslint-disable-next-line no-undef
            const uniqueImpressionsContainer = impressionsContainer.filter((obj, index, self) => index === self.findIndex((o) => o.item_id === obj.item_id && o.item_name === obj.item_name));

            return uniqueImpressionsContainer;
        }

        window.impressionsContainer = dataPushDataLayerObj();

        if (window.impressionsContainer.length > 0) {
            const newProducts = document.querySelectorAll(".viewItemListTrigger:not(.observed)");
            newProducts.forEach((product) => {
                observer.observe(product);
                product.classList.add("observed");
            });

            window.totalGrid = document.querySelectorAll(".viewItemListTrigger");

            $(".container").on("click", ".search-results__show-more .btn-page", function (e) {
                e.preventDefault();
                let loaded = false;
                $(document).ajaxComplete((event, xhr, settings) => {
                    if (settings.url.includes("Search-UpdateGrid") && !loaded) {
                        loaded = true;

                        window.impressionsContainer = dataPushDataLayerObj();
                        const firstGrid = document.querySelectorAll(".viewItemListTrigger");
                        let otherGrid = Array.from(firstGrid).filter((element, index) => index >= window.totalGrid.length);

                        if (otherGrid.length > 12) {
                            otherGrid = [];
                        }

                        window.totalGrid = [...window.totalGrid, ...otherGrid];
                    }
                });
            });
        }

        CBTController.observeBanners(bannerObserver);
    }

    /* Update Product Tile data-cbt attribute with actual index so it works with "Show more" feature */
    static updateTilesPosition(nodes) {
        const productCollection = [];
        var productCounter = CBTController.getProductCounter();

        for (const tempNode of nodes) {
            const dataCollectionObj = CBTController.parseJSON(tempNode.getAttribute("data-cbt"));
            if (dataCollectionObj && dataCollectionObj.event === "select_item" && dataCollectionObj.ecommerce.items && dataCollectionObj.ecommerce.items.length) {
                var item = dataCollectionObj.ecommerce.items[0];

                if (!productCollection.includes(item.item_id)) {
                    productCollection.push(item.item_id);
                    productCounter += 1;
                }
                item.index = productCounter;
                tempNode.dataset.cbt = JSON.stringify(dataCollectionObj);
            }
        }
    }

    /**
     * Handles links in the given node.
     * @param {Object} node - The node to process.
     * @returns {boolean} - Returns false if no elements with data-cbt attribute are found, otherwise returns true.
     */
    static handleLinks(node) {
        const allCBTData = node.querySelectorAll("[data-cbt]");

        if (!allCBTData.length) {
            return false;
        }

        // Call updateTilesPosition to avoid querying document another time
        CBTController.updateTilesPosition(allCBTData);

        /**
     * Sets the data-cbt attribute of the given child nodes
     * @param {NodeList} childs - the child nodes to set the attribute on
     * @param {string} data - the data to set the attribute to
     */
        function setChildData(childs, data) {
            for (let i = 0; i < childs.length; i += 1) {
                if (childs[i].nodeType === 1) {
                    if (childs[i].getAttribute("data-cbt")) continue;
                    childs[i].setAttribute("data-cbt", data);
                    if (childs[i].childNodes.length) {
                        setChildData(childs[i].childNodes, data);
                    }
                }
            }
        }

        /**
        * Sets the data-selected attribute of the child nodes of the given element
        * @param {NodeList} childs - the child nodes of the given element
        * @param {string} data - the data to be set
        */
        function setChildDataForRefinementSelectionState(childs, data) {
            for (let i = 0; i < childs.length; i += 1) {
                if (childs[i].nodeType === 1) {
                    if (childs[i].getAttribute("data-selected")) continue;
                    childs[i].setAttribute("data-selected", data);
                    if (childs[i].childNodes.length) {
                        setChildDataForRefinementSelectionState(childs[i].childNodes, data);
                    }
                }
            }
        }

        for (const tempNode of allCBTData) {
            const dataStr = tempNode.getAttribute("data-cbt");
            const refinementSelectionStateDataStr = tempNode.getAttribute("data-selected");
            const dataObj = CBTController.parseJSON(dataStr);

            if (!dataObj) continue;

            if (
                typeof dataObj.eventTypes !== "undefined"
        && dataObj.eventTypes.includes("link")
            ) {
                if (tempNode.childNodes.length) {
                    setChildData(tempNode.childNodes, dataStr);
                    if (refinementSelectionStateDataStr) {
                        setChildDataForRefinementSelectionState(tempNode.childNodes, refinementSelectionStateDataStr);
                    }
                }

                if (
                    typeof dataObj.eventTypes !== "undefined"
        && dataObj.eventTypes.includes("add")
                ) {
                    const dynamicNodes = document.querySelectorAll(dataObj.selector);
                    if (dynamicNodes.length) {
                        for (const tempDynamicNode of dynamicNodes) {
                            const newDataObj = CBTController.parseJSON(dataStr);
                            const eventTypes = newDataObj.eventTypes.split(",");
                            eventTypes.splice(eventTypes.indexOf("add"), 1);
                            newDataObj.eventTypes = eventTypes.join(",");
                            tempDynamicNode.setAttribute("data-cbt", JSON.stringify(newDataObj));
                        }
                        tempNode.removeAttribute("data-cbt");
                    }
                }
            }
        }
    }

    /**
    * Runs the AJAXListener
    */
    static AJAXListenerRun() {
        const listenerSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
            const callback = this.onreadystatechange;
            this.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const headers = this.getAllResponseHeaders();
                    if (headers.includes("application/json")) {
                        const myArr = CBTController.parseJSON(this.responseText);
                        if (myArr.cbt_data || myArr.cbt_data_productSet) {
                            const cbtData = Array.isArray(myArr.cbt_data) ? myArr.cbt_data : [myArr.cbt_data];
                            cbtData.forEach((result) => {
                                CBTController.dataPush(result);
                            });
                            CBTController.dataPush(myArr.cbt_data_productSet);
                        }
                    }

                    if (headers.includes("text/html")) {
                        clearTimeout(CBTController.timeout);
                        CBTController.timeout = setTimeout(() => {
                            CBTController.findAllDataDOM(document, false);
                        }, 1);
                    }
                }
                if (callback) {
                    callback.apply(this, arguments);
                }
            };
            listenerSend.apply(this, arguments);
        };
    }

    // run DOM updates listener, to find all cbt-data added to DOM
    static DOMListenerRun() {
        var timeout = null;
        let observer = new MutationObserver(function () {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                CBTController.handleLinks(document);
            }, 1000);
        });
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
    }

    static hoverListenerRun() {
        let timeout = null;
        document.addEventListener("mouseover", function (event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                const hoverDelay = cbtSitePreferences.CBT_HOVER_DELAY || 1000; // delay for hover event (ms)
                let node = event.target;
                let data = CBTController.parseJSON(node.getAttribute("data-cbt"));
                if (!data) {
                    return;
                }
                if (data.eventTypes && data.eventTypes.indexOf("hover") !== -1) {
                    timeout = setTimeout(function () {
                        if (node.options) {
                            data.label = node.options[node.options.selectedIndex].text;
                        }
                        if (!data.action) {
                            data.action = "hover";
                        }
                        data.category = "Hover";
                        CBTController.dataPush(data);
                    }, hoverDelay);
                }
            }
        });

        document.addEventListener("mouseout", function (event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                clearTimeout(timeout);
            }
        });
    }

    static clickListenerRun() {
        let allContainers = document.querySelectorAll("body,.container");
        for (let i = 0; i < allContainers.length; i += 1) {
            let tempNode = allContainers[i];
            tempNode.addEventListener("click", function (event) {
                var target = event.target;
                // if the target doesn't have data-cbt, find the closest parent with it
                if (!target || !target.getAttribute("data-cbt")) {
                    target = target.closest("[data-cbt]");
                }

                if (target && target.getAttribute("data-cbt")) {
                    let node = target;
                    let data = CBTController.parseJSON(node.getAttribute("data-cbt"));
                    if (data && data.eventTypes && data.eventTypes.indexOf("click") !== -1) {
                        if (data.event !== "select_item") {
                            if (!data.action) {
                                data.action = "click";
                            }
                            data.category = "Click";
                        }

                        // persist select_item data for view_item and add_to_cart events
                        if (data.event === "select_item") {
                            var persistentUrl = $("input[name='cbt-persistent-data-url']");
                            if (persistentUrl.length && persistentUrl[0].value) {
                                navigator.sendBeacon(persistentUrl[0].value, JSON.stringify({ data: data }));
                            }
                        }

                        if (data.event === "share" || data.event === "menu_click" || data.event === "product_filter_plp") {
                            delete data.label;
                            delete data.action;
                            delete data.category;
                            delete data.action;
                        }

                        if (data.event === "form_submit" || data.event === "login" || data.event === "account_activity") {
                            delete data.category;
                            delete data.action;
                        }

                        if (data.event === "product_filter_plp") {
                            window.gridload = true;
                            window.impressionsContainer = [];
                        }

                        if (data.event === "product_filter_plp" && node.getAttribute("data-selected") === "true") {
                            return;
                        }

                        if (data.event === "product_filter_pdp" || data.event === "product_filter_qv") {
                            if (node.classList.contains("selected")) return;
                            delete data.label;
                            delete data.action;
                            delete data.category;
                        }

                        if (data.event === "banner_click") {
                            delete data.category;
                            delete data.action;

                            var $bannerContent = $(node).closest("[data-banner-index]");

                            // only for large promo banner that data attr is a child, and not a parent
                            if (!$bannerContent.length) {
                                $bannerContent = $(node).find("[data-banner-index]");
                            }

                            var bannerIndex = $bannerContent?.length ? $bannerContent.data("bannerIndex") : 0;
                            data.creative_slot = bannerIndex;

                            var bannerLocation = CBTController.getBannerLocation(data);
                            data.banner_location = bannerLocation + "-" + bannerIndex;
                        }

                        const liveClickIndex = liveClick.indexOf(data.event);
                        if (liveClickIndex === -1) {
                            liveClick.push(data.event);
                            setTimeout(() => {
                                const idx = liveClick.indexOf(data.event);
                                if (idx !== -1) {
                                    liveClick.splice(idx, 1);
                                }
                            }, 10);
                        } else {
                            return;
                        }
                        CBTController.dataPush(data);
                    }
                }
            });
        }
    }

    static changeListenerRun() {
        document.addEventListener("change", (event) => {
            const { target } = event;
            if (target && target.getAttribute("data-cbt")) {
                const node = target;
                const data = CBTController.parseJSON(node.getAttribute("data-cbt"));
                if (data && data.eventTypes && data.eventTypes.includes("change")) {
                    if (node.options) {
                        data.label = node.options[node.options.selectedIndex].text;
                        if (data.event === "product_filter_plp") {
                            window.gridload = true;
                            const ifSorting = data.filter_type === "Sort" || data.filter_type === "Sorting";
                            if (ifSorting) {
                                if (node.options[node.options.selectedIndex].dataset.id) {
                                    var sortingRuleOnChange = (node.options[node.options.selectedIndex].dataset.id).split("-");
                                    data.filter_value = "";
                                    for (var i = 0; i < sortingRuleOnChange.length; i += 1) {
                                        if (sortingRuleOnChange.length - i === 0) {
                                            data.filter_value += sortingRuleOnChange[i];
                                        } else {
                                            data.filter_value += sortingRuleOnChange[i] + " ";
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (typeof node.attributes.type !== "undefined" && node.attributes.type.nodeValue === "checkbox") {
                        if (!data.label) {
                            data.label = node.checked ? "checked" : "unchecked";
                        }
                    }
                    if (!data.label) {
                        data.label = node.value;
                    }
                    if (!data.action) {
                        data.action = "change";
                    }
                    data.category = "Click";

                    if (data.event === "share" || data.event === "menu_click" || data.event === "product_filter_plp") {
                        delete data.label;
                        delete data.action;
                        delete data.category;
                    }

                    if (data.event === "product_filter_pdp" || data.event === "product_filter_qv") {
                        data.filter_value = data.label;
                        delete data.label;
                        delete data.action;
                        delete data.category;
                    }
                }
                CBTController.dataPush(data);
            }
        });
    }

    /**
    * Static method to handle SFRAClick events
    */
    static SFRAClick() {
        const cbtData = document.getElementById("cbt-sfra-links").value;
        document.querySelector(".menu-footer.locate-store").dataset.cbt = cbtData;

        /**
        * Sets the menu item data for the given section
        * @param {Object} menuItems - the menu item data
        * @param {string} section - the section to set the menu item data for
        */
        function setMenuItemData(menuItems, section) {
            menuItems.forEach((item) => {
                const tempCbt = JSON.parse(cbtData);
                tempCbt.menu_item_name = item.textContent;
                tempCbt.menu_item_section = section;
                item.dataset.cbt = JSON.stringify(tempCbt);
            });
        }

        const cbtAccountMenus = document.querySelectorAll("#collapsible-account li > a");
        setMenuItemData(cbtAccountMenus, "Account");

        const cbtCustomerServiceMenus = document.querySelectorAll("#collapsible-customer-service li > a");
        setMenuItemData(cbtCustomerServiceMenus, "Customer Service");

        const cbtAboutMenus = document.querySelectorAll("#collapsible-about li > a");
        setMenuItemData(cbtAboutMenus, "About");
    }

    static SFRABaseFixes() {
        const eventCleaner = setInterval(() => {
            $(".container").off("change", "[name=sort-order]");
            let foundSelect = false;
            let foundSelectColor = false;
            $._data(document).events.change.forEach((event) => {
                if (event.selector === "select[class*=\"select-\"], .options-select") {
                    if (foundSelect) {
                        event.handler = () => {};
                    } else {
                        foundSelect = true;
                    }
                }
            });
            $._data(document).events.click.forEach((event) => {
                if (event.selector === "[data-attr=\"color\"] button") {
                    if (foundSelectColor) {
                        event.handler = () => {};
                    } else {
                        foundSelectColor = true;
                    }
                }
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(eventCleaner);
        }, 10000);

        /* eslint-disable */
        $(document).on("change", "[name=sort-order]", (function (t) {
            t.preventDefault(),
            $.spinner().start(),
            $(this).trigger("search:sort", this.value),
            $.ajax({
                url: this.value,
                data: {
                    selectedUrl: this.value
                },
                method: "GET",
                success: function (t) {
                    $(".product-grid").empty().html(t),
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
        ));

        $('body').on('promotion:success', function () {
            window.location.reload();
        });
        /* eslint-enable */
    }

    static cartUpdateListenerRun() {
        $("body").on("cart:beforeUpdate", function () {
            const $buttons = $("a.checkout-btn[data-cbt]");
            if ($buttons.length === 0) {
                return;
            }
            // Disable checkout button/s
            $buttons.addClass("disabled");
        });

        $("body").on("cart:update", function () {
            const $buttons = $("a.checkout-btn[data-cbt]");
            if ($buttons.length === 0) {
                return;
            }

            const url = $buttons.first().data("actionToUpdateCbtData");
            if (!url) {
                // Enable checkout button/s
                $buttons.removeClass("disabled");
                return;
            }

            // Disable checkout button/s before the AJAX call
            $buttons.addClass("disabled");

            $.ajax({
                url: url,
                method: "GET",
                success: function (response) {
                    $buttons.each(function () {
                        $(this).attr("data-cbt", response.updated_checkout_data);
                    });
                },
                complete: function () {
                    // Enable checkout button/s after the AJAX call completes
                    $buttons.removeClass("disabled");
                }
            });
        });
    }

    /**
    * Pushes faq_questions event when a FAQ accordion item is opened.
    */
    static faqQuestionsListenerRun() {
        $(document).off("shown.bs.collapse.cbtfaqQuestions", ".accordian-pdesign .collapse");
        $(document).on("shown.bs.collapse.cbtfaqQuestions", ".accordian-pdesign .collapse", function () {
            var collapseId = $(this).attr("id");
            var $button = $(".accordian-pdesign .card-header button[aria-controls='" + collapseId + "']").first();
            var clickText = ($button.text() || "").trim();
            var faqIndex = $(".accordian-pdesign .card-header button").index($button) + 1;

            if (!clickText) {
                return;
            }

            CBTController.dataPush({
                event: "faq_questions",
                click_text: clickText,
                faq_index: faqIndex > 0 ? faqIndex : 1
            });
        });
    }

    /**
    * Rebinds faq_questions listener after AJAX content updates.
    */
    static faqQuestionsAjaxListenerRun() {
        CBTController.faqQuestionsListenerRun();

        $(document).off("ajaxComplete.cbtfaqQuestions");
        $(document).on("ajaxComplete.cbtfaqQuestions", function () {
            CBTController.faqQuestionsListenerRun();
        });
    }

    /**
    * Sets up a listener to monitor and handle interactions with the Botmaker chat iframe.
    * Binds an event listener to the chat minimize button inside the iframe to trigger a data push event when the chat is opened.
    */
    static chatListenerRun() {
        const observer = new MutationObserver(function () {
            const isEventAttached = bindChatClickEvent();
            if (isEventAttached) {
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true, subtree: true
        });
    }

    /**
    * Sets up event listeners for vehicle selection interactions on the page.
    * Handles click events on vehicle selector buttons and change events on vehicle selector dropdowns,
    * triggering data payload pushes for analytics or tracking purposes. Debounces PLP dropdown changes
    * to avoid excessive data pushes.
    */
    static vehicleSelectListenerRun() {
        $(document).off("click.cbtVehicleSelect", ".vehicle-selector-container .btn-vehicle-selector");
        $(".container").off("change.cbtVehicleSelect", ".vehicle-selector-search .vehicle-selector-dropdown[data-filterby]");

        // Home/PDP
        $(document).on("click.cbtVehicleSelect", ".vehicle-selector-container .btn-vehicle-selector", function () {
            var $container = $(this).closest(".vehicle-selector-container");
            var selectorLocation = getVehicleSelectorLocation($container);

            if (selectorLocation === "plp") {
                return;
            }

            CBTController.dataPush(buildVehicleSelectPayload($container));
        });

        // PLP
        $(".container").on("change.cbtVehicleSelect", ".vehicle-selector-search .vehicle-selector-dropdown[data-filterby]", function () {
            var $container = $(this).closest(".vehicle-selector-container");

            clearTimeout(CBTController.vehicleSelectPLPTimeout);
            CBTController.vehicleSelectPLPTimeout = setTimeout(function () {
                CBTController.dataPush(buildVehicleSelectPayload($container));
            }, 4000);
        });
    }

    /**
    * Determines the context of a search form based on its closest parent container.
    * Returns a string indicating the type of search location: "model_search" if the form is within a vehicle selector,
    * "second_search" if within a mobile search container, or "global_search" otherwise.
    *
    * @param {jQuery} $form - The jQuery-wrapped form element to evaluate.
    * @returns {string} - The resolved search location identifier.
    */
    static resolveSearchLocation($form) {
        if ($form.closest(".vehicle-selector-searcher").length) {
            return "second_search";
        }

        if ($form.closest(".search-mobile").length) {
            return "model_search";
        }

        return "global_search";
    }

    /**
    * Normalizes a search term by converting undefined or null values to an empty string and trimming whitespace.
    * @param {string} value - The input search term to normalize.
    * @returns {string} The normalized and trimmed search term.
    */
    static normalizeSearchTerm(value) {
        return (value || "").trim();
    }

    /**
    * Extracts and normalizes the search term ("q" parameter) from a given URL.
    * @param {string} href - The URL string from which to extract the search term.
    * @returns {string} The normalized search term if present, otherwise an empty string.
    */
    static getSearchTermFromHref(href) {
        if (!href) {
            return "";
        }

        try {
            var parsedUrl = new URL(href, window.location.origin);
            return CBTController.normalizeSearchTerm(parsedUrl.searchParams.get("q"));
        } catch (e) {
            return "";
        }
    }

    /**
    * Determines if the current search event is a duplicate of the last search event within a 1.5 second interval.
    * Prevents rapid, repeated search events with identical parameters from being processed multiple times.
    *
    * @param {Object} payload - The search event payload containing search parameters.
    * @param {string} payload.search_term - The search term entered by the user.
    * @param {string} payload.search_location - The location context of the search.
    * @param {string} payload.search_type - The type/category of the search.
    * @param {string} payload.page_location - The page or section where the search was performed.
    * @returns {boolean} True if the search event is a duplicate within 1.5 seconds; otherwise, false.
    */
    static isDuplicateSearchEvent(payload) {
        var eventKey = [
            payload.search_term,
            payload.search_location,
            payload.search_type,
            payload.page_location
        ].join("|");
        var now = Date.now();

        if (
            CBTController.lastSearchEvent
            && CBTController.lastSearchEvent.key === eventKey
            && (now - CBTController.lastSearchEvent.time) < 1500
        ) {
            return true;
        }

        CBTController.lastSearchEvent = {
            key: eventKey,
            time: now
        };

        return false;
    }

    /**
    * Retrieves the value of the search track URL from the input field with the name 'cbt-search-track-url'.
    * @returns {string} The value of the search track URL input field, or an empty string if the field does not exist or has no value.
    */
    static getSearchTrackUrl() {
        var $trackUrlField = $("input[name='cbt-search-track-url']");

        if (!$trackUrlField.length) {
            return "";
        }

        return $trackUrlField.first().val() || "";
    }

    /**
    * Notifies listeners when backend search tracking fails.
    *
    * @param {string} reason - Failure reason identifier.
    * @param {string} details - Optional failure details.
    */
    static notifySearchError(reason, details) {
        $(document).trigger("cbt:searchBackendError", [{
            reason: reason || "unknown",
            details: details || ""
        }]);
    }

    /**
    * Sends a search event payload to the backend for tracking purposes.
    * Uses sendBeacon first and falls back to jQuery AJAX when needed.
    *
    * @param {Object} payload - The search event data to be sent to the backend.
    */
    static sendSearchEventToBackend(payload) {
        var trackUrl = CBTController.getSearchTrackUrl();

        if (!trackUrl || !payload) {
            return;
        }

        var requestBody = JSON.stringify({
            data: payload
        });

        if (navigator.sendBeacon) {
            try {
                if (navigator.sendBeacon(trackUrl, requestBody)) {
                    return;
                }

                CBTController.notifySearchError("sendBeaconReturnedFalse", "sendBeacon returned false");
            } catch (error) {
                CBTController.notifySearchError("sendBeaconException", error && error.message ? error.message : "sendBeacon exception");
            }
        }

        try {
            $.ajax({
                url: trackUrl,
                method: "POST",
                contentType: "application/json; charset=UTF-8",
                data: requestBody
            }).fail(function (jqXHR, textStatus, errorThrown) {
                CBTController.notifySearchBackendError("ajaxFailed", errorThrown || textStatus || "ajax failed");
            });
        } catch (error) {
            CBTController.notifySearchBackendError("ajaxException", error && error.message ? error.message : "ajax exception");
        }
    }
    /**
    * Triggers and pushes a search event based on the provided form and search parameters.
    *
    * Normalizes the search term, constructs the event payload, checks for duplicates,
    * and sends the event data to the backend and data layer if valid.
    *
    * @param {jQuery} $form - The jQuery form element from which the search originated.
    * @param {string} searchType - The type/category of the search (e.g., 'product', 'category').
    * @param {string} rawTerm - The raw search term input by the user.
    * @returns {void}
    */
    static pushSearchEvent($form, searchType, rawTerm) {
        var term = CBTController.normalizeSearchTerm(rawTerm);

        if (!$form || !$form.length || !term) {
            return;
        }

        var payload = {
            event: "search",
            search_term: term,
            search_location: CBTController.resolveSearchLocation($form),
            search_type: searchType,
            page_location: window.location.href
        };

        if (CBTController.isDuplicateSearchEvent(payload)) {
            return;
        }

        CBTController.sendSearchEventToBackend(payload);
        CBTController.dataPush(payload);
    }

    /**
    * Attaches and manages event listeners for the simple search form, handling search submissions via keyboard, button click, suggestion selection, and form submission.
    * Ensures that search events are tracked and pushed to the CBTController with appropriate context (direct or recommendation).
    * Removes any previously attached listeners within the '.cbtSearchEvent' namespace before reattaching to prevent duplicate handlers.
    *
    * @static
    * @memberof CBTController
    */
    static searchListenerRun() {
        var eventNamespace = ".cbtSearchEvent";
        var $document = $(document);
        var searchFormSelector = "form[name='simpleSearch']";

        $document.off("keydown" + eventNamespace, searchFormSelector + " input.search-field");
        $document.on("keydown" + eventNamespace, searchFormSelector + " input.search-field", function (event) {
            if (event.key !== "Enter" && event.which !== 13) {
                return;
            }

            var $form = $(this).closest(searchFormSelector);
            if ($form.find(".suggestions .item.selected").length) {
                return;
            }

            CBTController.pushSearchEvent($form, "direct", $(this).val());
        });

        $document.off("click" + eventNamespace, searchFormSelector + " button[name='search-button']");
        $document.on("click" + eventNamespace, searchFormSelector + " button[name='search-button']", function () {
            if ($(this).attr("type") !== "submit") {
                return;
            }

            var $form = $(this).closest(searchFormSelector);
            CBTController.pushSearchEvent($form, "direct", $form.find("input[name='q']").first().val());
        });

        $document.off("click" + eventNamespace, searchFormSelector + " .suggestions .item a");
        $document.on("click" + eventNamespace, searchFormSelector + " .suggestions .item a", function () {
            var $anchor = $(this);
            var $form = $anchor.closest(searchFormSelector);
            var hrefTerm = CBTController.getSearchTermFromHref($anchor.attr("href"));
            var inputTerm = $form.find("input[name='q']").first().val();

            CBTController.pushSearchEvent($form, "recommendation", hrefTerm || inputTerm || ($anchor.text() || "").trim());
        });

        $document.off("submit" + eventNamespace, searchFormSelector);
        $document.on("submit" + eventNamespace, searchFormSelector, function () {
            var $form = $(this);
            CBTController.pushSearchEvent($form, "direct", $form.find("input[name='q']").first().val());
        });
    }
}

/**
 * initial cbt-data search and dataLayer push on page
 * AJAX listener run
 */

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("cbt-sfra-links") && cbtSitePreferences.CBT_MENU_CLICK) {
        CBTController.SFRAClick();
    }
    CBTController.findAllDataDOM(document, true);
    CBTController.AJAXListenerRun();
    CBTController.DOMListenerRun();
    CBTController.SFRABaseFixes();

    if (cbtSitePreferences.CBT_CLICK) {
        CBTController.clickListenerRun();
        CBTController.changeListenerRun();
        CBTController.faqQuestionsAjaxListenerRun();
        CBTController.vehicleSelectListenerRun();
        CBTController.chatListenerRun();
        CBTController.searchListenerRun();
    }

    if (cbtSitePreferences.CBT_HOVER) {
        CBTController.hoverListenerRun();
    }
    if (cbtSitePreferences.CBT_BEGIN_CHECKOUT_TRIGGER === 2) {
        CBTController.cartUpdateListenerRun();
    }
});
